// removed by extract-text-webpack-plugin
module.exports = {"component":"dPLyOkm2zS_w4VJyHdzVe"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ThankYouPage/BoletoPage/BoletoDefault/boletoDefault.css
// module id = 1270
// module chunks = 2